import {callApi} from '../api'
import _ from 'lodash';

export const GET_MY_REPORTS = 'GET_MY_REPORTS';
export const DELETE_MY_REPORT = 'DELETE_MY_REPORT';
export const SUBMIT_MY_REPORT = 'SUBMIT_MY_REPORT';

export function getMyReports(cb, month, year) {
    return function (dispatch, getState) {
        let userId = getState().authentication.user._id;
        let first = new Date(year, month, 1);
        let last = new Date(year, month + 1, 1);
        return callApi(dispatch, getState, 'GET', '/reports?userId=' + userId + '&createdAt[$gte]=' + first.getTime() + '&createdAt[$lt]=' + last.getTime(), null, GET_MY_REPORTS, cb);
    }
}

export function deleteMyReport(cb, reportId) {
    return function (dispatch, getState) {
        return callApi(dispatch, getState, 'DELETE', '/reports/' + reportId, null, DELETE_MY_REPORT, cb);
    }
}

export function submitMyReport(cb, data) {
    return function (dispatch, getState) {
        let now = new Date();
        if ((now.getMonth() !== data.month) || (now.getFullYear() !== data.year)) {
            let createdAt = new Date(data.year, data.month + 1, 0, now.getHours(), now.getMinutes(), now.getSeconds(), now.getMilliseconds());
            data.createdAt = createdAt.toISOString();
        }
        return callApi(dispatch, getState, 'POST', '/reports', _.omit(data, ['year', 'month']), SUBMIT_MY_REPORT, cb);
    }
}



// WEBPACK FOOTER //
// ./src/actions/myreports.js